'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fetch = require('../utils/fetch');

var _fetch2 = _interopRequireDefault(_fetch);

var _yidun = require('./types/yidun');

var _yidun2 = _interopRequireDefault(_yidun);

var _ivc = require('./types/ivc');

var _ivc2 = _interopRequireDefault(_ivc);

var _af = require('./types/af');

var _af2 = _interopRequireDefault(_af);

var _wjd = require('./types/wjd');

var _wjd2 = _interopRequireDefault(_wjd);

var _toast = require('../toast');

var _toast2 = _interopRequireDefault(_toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AntiBrush = function (_PureComponent) {
  _inherits(AntiBrush, _PureComponent);

  function AntiBrush(props) {
    _classCallCheck(this, AntiBrush);

    var _this = _possibleConstructorReturn(this, (AntiBrush.__proto__ || Object.getPrototypeOf(AntiBrush)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      visibleModal: false,
      sTokenId: '',
      verifyType: '',
      captchaId: ''
    };
    _this.isPropsLock = false;
    return _this;
  }

  _createClass(AntiBrush, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getRiskCheck();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var visibleModal = this.state.visibleModal;


      if (nextProps.visible && visibleModal !== nextProps.visible) {
        this.getRiskCheck(nextProps);
      }
    }

    // 风险检查


    // 判断缺少参数

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          bizType = _props.bizType,
          data = _props.data,
          sId = _props.sId;
      var _state = this.state,
          visibleModal = _state.visibleModal,
          verifyType = _state.verifyType,
          sTokenId = _state.sTokenId,
          captchaId = _state.captchaId;


      if (!visibleModal) {
        return null;
      }

      // yidun网易易顿
      if (verifyType === 'yidun') {
        return _react2.default.createElement(_yidun2.default, {
          data: data,
          bizType: bizType,
          sTokenId: sTokenId,
          captchaId: captchaId,
          onClose: function onClose() {
            return _this2.onClose();
          },
          onSuccess: function onSuccess(ticket) {
            return _this2.onSuccess(ticket, data);
          }
        });
      }

      // wjd (众安科技)业务反欺诈 无间盾
      if (verifyType === 'wjd') {
        return _react2.default.createElement(_wjd2.default, {
          data: data,
          bizType: bizType,
          sTokenId: sTokenId,
          sId: sId,
          onClose: function onClose() {
            return _this2.onClose();
          },
          onSuccess: function onSuccess(ticket) {
            return _this2.onSuccess(ticket, data);
          }
        });
      }

      // af(众安科技)表示启用反欺诈服务验证
      if (verifyType === 'af') {
        return _react2.default.createElement(_af2.default, {
          className: className,
          data: data,
          bizType: bizType,
          sTokenId: sTokenId,
          sId: sId,
          onClose: function onClose() {
            return _this2.onClose();
          },
          onSuccess: function onSuccess(ticket) {
            return _this2.onSuccess(ticket, data);
          }
        });
      }

      return _react2.default.createElement(_ivc2.default, {
        className: className,
        data: data,
        sTokenId: sTokenId,
        onSuccess: function onSuccess(ticket) {
          return _this2.onSuccess(ticket, data);
        },
        onClose: function onClose() {
          return _this2.onClose();
        }
      });
    }
  }]);

  return AntiBrush;
}(_react.PureComponent);

AntiBrush.defaultProps = {
  visible: false,
  sId: '',
  bizType: '',
  data: '',
  className: '',
  onSuccess: function onSuccess() {},
  onClose: function onClose() {}
};
AntiBrush.propTypes = {
  visible: _propTypes2.default.bool,
  sId: _propTypes2.default.string,
  bizType: _propTypes2.default.string,
  data: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onSuccess: _propTypes2.default.func,
  onClose: _propTypes2.default.func
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onClose = function () {
    var onClose = _this3.props.onClose;


    _this3.setState({
      visibleModal: false
    });

    onClose && onClose();
  };

  this.onSuccess = function (ticket, data) {
    var onSuccess = _this3.props.onSuccess;


    _this3.setState({
      visibleModal: false
    });

    onSuccess && onSuccess(ticket, data);
  };

  this.getRiskCheck = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props;
    var bizType = props.bizType,
        data = props.data,
        visible = props.visible;


    if (!visible) {
      return false;
    }

    // props触发多次，添加锁
    if (_this3.isPropsLock) {
      return false;
    }

    _this3.isPropsLock = true;

    if (_this3.isLackProps(props)) {
      console.error('缺少参数props== [sId bizType data], 请检查传值');
      return false;
    }

    _fetch2.default.fetch({
      path: '/facilities/open/v1/common/security/rc',
      server: 'api',
      method: 'GET',
      data: {
        data: data,
        bizType: bizType
      },
      timeout: 7000
    }).then(function (_ref) {
      var isSuccess = _ref.isSuccess,
          result = _ref.result,
          errorMsg = _ref.errorMsg;

      _this3.isPropsLock = false;

      if (isSuccess && result) {
        var riskLevel = result.riskLevel,
            sTokenId = result.sTokenId,
            verifyType = result.verifyType,
            captchaId = result.captchaId;

        // 风险等级：0-无风险，1-初级风险，2-中级风险，3-高风险，4-极度危险

        if (+riskLevel === 0) {
          _this3.onSuccess(result.ticket, data);
        } else {
          _this3.setState({
            sTokenId: sTokenId,
            // wjd (众安科技)业务反欺诈 无间盾，af(众安科技)表示启用反欺诈服务验证，yidun(网易易顿)，ivc表示启用图片验证（页面需要加载图片验证码）
            verifyType: verifyType,
            captchaId: captchaId,
            visibleModal: true
          });
        }
      } else {
        _this3.onClose();

        errorMsg && _toast2.default.warning(errorMsg);
      }
    }).catch(function () {
      _this3.onClose();
    });
  };

  this.isLackProps = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props;
    var sId = props.sId,
        bizType = props.bizType,
        data = props.data;

    return !(sId && bizType && data);
  };
};

exports.default = AntiBrush;